import { useEffect } from "react";

export const useModalEvent = () => {
  const ModalEvents = {
    TaskTemplateModal: {
      Id: "dd_create-update-task-template-modal",
      Event: "toggle.tasktemplatemodal",
    },
    CreateBoardModal: {
      Id: "dd_create-board-modal",
      Event: "toggle.createboard.modal",
    },
    CreateTaskModal: {
      Id: "dd_create-task-modal",
      Event: "toggle.createtask.modal",
    },
    CreateViewModal: {
      Id: "dd_create-view-modal",
      Event: "toggle.createview.modal",
    },
    DeleteConfirmationModal: {
      Id: "dd_delete-task-confirmation-modal",
      Event: "toggle.deleteconfirmation.modal",
    },
    AccessModal: {
      Id: "dd_access-modal",
      Event: "toggle.access.modal",
    },
    CreateTaskTypeModal: {
      Id: "dd_create-task-type-modal",
      Event: "toggle.createtasktype.modal",
    },
    DeleteTaskTypeConfirmationModal: {
      Id: "dd_delete-tasktype-confirmation-modal",
      Event: "toggle.deletetasktypeconfirmation.modal",
    },
    CreateStageModal: {
      Id: "dd_create-stage-modal",
      Event: "toggle.createstage.modal",
    },
    UpdateStageModal: {
      Id: "dd_update-stage-modal",
      Event: "toggle.updatestage.modal",
    },
    DeleteBoardConfirmationModal: {
      Id: "dd_delete-board-confirmation-modal",
      Event: "toggle.deleteboardconfirmation.modal",
    },
    ArchiveBoardConfirmationModal: {
      Id: "dd_archive-task-board-confirmation-modal",
      Event: "toggle.archiveboardconfirmation.modal",
    },
    ImportTasks: {
      Id: "dd_import-tasks-modal",
      Event: "toggle.importtasks.modal",
    },
    ImportTemplates: {
      Id: "dd_import-task-templates-modal",
      Event: "toggle.importtasktemplates.modal",
    },
    DeleteViewConfirmationModal: {
      Id: "dd_delete-view-confirmation-modal",
      Event: "toggle.deleteview.modal",
    },
    ExtendedDateModal: {
      Id: "dd_extend-date-modal",
      Event: "toggle.extendeddate.modal",
    },
    UndoExtendedDateModal: {
      Id: "dd_undo-extend-date-modal",
      Event: "toggle.undoextendeddate.modal",
    },
    WelcomeModal: {
      Id: "welcomeModal",
      Event: "toggle.welcome.modal",
    },
    RolloverTasks: {
      Id: "rolloverTasksModal",
      Event: "toggle.rollovertasks.modal",
    },
    BulkUpdateTaskModalFromGrid: {
      Id: "dd_grid-bulk-update-tasks-modal",
      Event: "toggle.gridbulkupdatetasks.modal",
    },
    BulkUpdateTaskModalFromActions: {
      Id: "dd_actions-bulk-update-tasks-modal",
      Event: "toggle.actionsbulkupdatetasks.modal",
    },
    CreateTaxReturnTaskTypeModal: {
      Id: "dd_create-tax-return-task-type-modal",
      Event: "toggle.createtaxreturntasktype.modal",
    },
    RequestBoardAccessModal: {
      Id: "dd_request-board-access-modal",
      Event: "toggle.requestboardaccess.modal",
    },
    CustomFieldGroupModal: {
      Id: "dd_custom-field-group-modal",
      Event: "toggle.customfieldgroup.modal",
    },
    DeleteGroupConfirmationModal: {
      Id: "dd_delete-group-confirmation-modal",
      Event: "toggle.deletegroupconfirmation.modal",
    },
    InactivateFieldGroupModal: {
      Id: "inactivate-field-group-confirmation-modal",
      Event: "toggle.inactivatefieldgroupconfirmation.modal",
    },
    DeleteTaskTemplateModal: {
      Id: "dd_delete-task-template-modal",
      Event: "toggle.deletetasktemplate.modal",
    },
  };

  const toggleModal = (eventType, detail = undefined) => {
    const event = new CustomEvent(eventType.Event, {
      detail: detail,
    });

    document.dispatchEvent(event);
  };

  const getElementId = (eventType, uniqueId) => {
    let result = `${eventType.Id}`;

    if (uniqueId) result = `${eventType.Id}-${uniqueId}`;

    return result;
  };

  const useRegisterEvent = (eventType, event, uniqueId = undefined) => {
    useEffect(() => {
      var el = document;
      if (uniqueId) {
        el = document.getElementById(getElementId(eventType, uniqueId));
      }
      if (eventType) {
        el.removeEventListener(eventType.Event, event);
        el.addEventListener(eventType.Event, event);
        return () => {
          el.removeEventListener(eventType.Event, event);
        };
      }
    }, []);
  };

  return { ModalEvents, getElementId, toggleModal, useRegisterEvent };
};

export default useModalEvent;
